import React from "react";
import { Card, CardActions, Button, CardContent, Typography, Box, } from "@mui/material";
import { Link } from "react-router-dom";
const ButtonCard = ({ to, startIcon, text, title, description, }) => {
    return (React.createElement(Card, { sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            minHeight: 170,
        } },
        React.createElement(CardContent, { sx: { flexGrow: 1 } },
            React.createElement(Box, { sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                } },
                startIcon,
                React.createElement(Typography, { variant: "h5", component: "div", sx: { marginLeft: 1 } }, title)),
            React.createElement(Typography, { variant: "body2", color: "text.secondary" }, description)),
        React.createElement(CardActions, null,
            React.createElement(Button, { sx: { backgroundColor: "#007549", color: "white" }, component: Link, to: to, variant: "contained" }, text))));
};
export default ButtonCard;
